import CtaBanner from '../../components/CtaBanner';

const FALLBACK_CTA = {
  headline: 'Ready to Grow Your Amazon Business?',
  subheadline:
    'Join hundreds of sellers who trust Nation Wholesale LLC for premium wholesale products, full compliance documentation, and unbeatable pricing.',
  button_label: 'Apply for Wholesale',
};

function CtaBannerSection({ settings }) {
  const cta = settings?.cta_banner || FALLBACK_CTA;

  // If an admin set a CTA button URL, the button links there; otherwise it
  // navigates to the dedicated wholesale application page.
  const buttonUrl = (cta.button_url || '').trim();
  const primaryProps = buttonUrl
    ? { primaryHref: buttonUrl }
    : { primaryTo: '/wholesale' };

  return (
    <CtaBanner
      headline={cta.headline || FALLBACK_CTA.headline}
      sub={cta.subheadline || FALLBACK_CTA.subheadline}
      primaryLabel={cta.button_label || FALLBACK_CTA.button_label}
      {...primaryProps}
      outlineLabel="Contact Us"
      outlineTo="/contact"
    />
  );
}

export default CtaBannerSection;
